import React, { useState } from 'react';
import { BarChart3, TrendingUp, Calendar, Download, Filter, Users, Building2, MessageSquare, Clock, CheckCircle2, AlertCircle, Package, DollarSign } from 'lucide-react';

const ReportsSobre = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('month');
  const [startDate, setStartDate] = useState('2025-11-01');
  const [endDate, setEndDate] = useState('2025-11-16');
  const [selectedReport, setSelectedReport] = useState('overview');

  // Statistiques globales
  const stats = {
    totalPharmacies: 15,
    activePharmacies: 12,
    totalPharmacists: 15,
    assignedPharmacists: 5,
    totalMessages: 15,
    pendingMessages: 3,
    resolvedMessages: 8,
    dutyWeeks: 4,
    publishedWeeks: 2,
  };

  // Données pour les graphiques (simulées)
  const pharmacyGrowth = [
    { month: 'Juin', count: 8 },
    { month: 'Juillet', count: 10 },
    { month: 'Août', count: 11 },
    { month: 'Septembre', count: 13 },
    { month: 'Octobre', count: 14 },
    { month: 'Novembre', count: 15 },
  ];

  const messagesByStatus = [
    { status: 'En attente', count: 3, color: 'bg-orange-500' },
    { status: 'En cours', count: 4, color: 'bg-blue-500' },
    { status: 'Résolus', count: 8, color: 'bg-green-500' },
  ];

  const topPharmacies = [
    { name: 'Pharmacie Dakar Centre', messages: 5, status: 'active' },
    { name: 'Pharmacie Thies Nord', messages: 3, status: 'active' },
    { name: 'Pharmacie Mbour', messages: 2, status: 'active' },
    { name: 'Pharmacie Saint-Louis', messages: 2, status: 'incomplete' },
    { name: 'Pharmacie Rufisque', messages: 1, status: 'active' },
  ];

  const dutyScheduleStats = [
    { period: 'Semaine 1', pharmacies: 3, published: true },
    { period: 'Semaine 2', pharmacies: 3, published: true },
    { period: 'Semaine 3', pharmacies: 3, published: false },
    { period: 'Semaine 4', pharmacies: 0, published: false },
  ];

  const handleExport = (format) => {
    alert(`Export en format ${format.toUpperCase()} en cours...`);
  };

  const reportTypes = [
    { id: 'overview', label: 'Vue d\'ensemble', icon: BarChart3 },
    { id: 'pharmacies', label: 'Pharmacies', icon: Building2 },
    { id: 'messages', label: 'Messages', icon: MessageSquare },
    { id: 'duty', label: 'Gardes', icon: Calendar },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="p-6">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6 border border-gray-200">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
              <BarChart3 className="text-white" size={24} />
            </div>
            
            <div className="flex-1">
              <h1 className="text-2xl font-bold text-gray-900">Rapports et Statistiques</h1>
              <p className="text-gray-600 text-sm">Analysez les performances de votre réseau</p>
            </div>

            <div className="flex space-x-2">
              <button
                onClick={() => handleExport('pdf')}
                className="flex items-center space-x-2 px-4 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-all font-medium text-sm border border-red-200"
              >
                <Download size={18} />
                <span>PDF</span>
              </button>
              <button
                onClick={() => handleExport('excel')}
                className="flex items-center space-x-2 px-4 py-2 bg-green-50 text-green-600 rounded-lg hover:bg-green-100 transition-all font-medium text-sm border border-green-200"
              >
                <Download size={18} />
                <span>Excel</span>
              </button>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-6 border border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-2">Type de rapport</label>
              <select
                value={selectedReport}
                onChange={(e) => setSelectedReport(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              >
                {reportTypes.map(type => (
                  <option key={type.id} value={type.id}>{type.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-2">Période</label>
              <select
                value={selectedPeriod}
                onChange={(e) => setSelectedPeriod(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              >
                <option value="week">Cette semaine</option>
                <option value="month">Ce mois</option>
                <option value="quarter">Ce trimestre</option>
                <option value="year">Cette année</option>
                <option value="custom">Personnalisée</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-2">Date début</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-2">Date fin</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
          </div>
        </div>

        {/* Main Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between mb-2">
              <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center">
                <Building2 className="text-white" size={20} />
              </div>
              <TrendingUp className="text-green-600" size={20} />
            </div>
            <p className="text-sm text-gray-600 mb-1">Pharmacies</p>
            <p className="text-3xl font-bold text-gray-900">{stats.totalPharmacies}</p>
            <p className="text-xs text-green-600 mt-1">{stats.activePharmacies} actives</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between mb-2">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <Users className="text-white" size={20} />
              </div>
              <TrendingUp className="text-blue-600" size={20} />
            </div>
            <p className="text-sm text-gray-600 mb-1">Pharmaciens</p>
            <p className="text-3xl font-bold text-gray-900">{stats.totalPharmacists}</p>
            <p className="text-xs text-blue-600 mt-1">{stats.assignedPharmacists} assignés</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between mb-2">
              <div className="w-10 h-10 bg-orange-600 rounded-lg flex items-center justify-center">
                <MessageSquare className="text-white" size={20} />
              </div>
              <AlertCircle className="text-orange-600" size={20} />
            </div>
            <p className="text-sm text-gray-600 mb-1">Messages</p>
            <p className="text-3xl font-bold text-gray-900">{stats.totalMessages}</p>
            <p className="text-xs text-orange-600 mt-1">{stats.pendingMessages} en attente</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between mb-2">
              <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center">
                <Calendar className="text-white" size={20} />
              </div>
              <CheckCircle2 className="text-purple-600" size={20} />
            </div>
            <p className="text-sm text-gray-600 mb-1">Semaines de garde</p>
            <p className="text-3xl font-bold text-gray-900">{stats.dutyWeeks}</p>
            <p className="text-xs text-purple-600 mt-1">{stats.publishedWeeks} publiées</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
          {/* Pharmacy Growth Chart */}
          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <TrendingUp size={20} className="mr-2 text-blue-600" />
              Évolution des pharmacies
            </h3>
            <div className="space-y-3">
              {pharmacyGrowth.map((item, index) => (
                <div key={index}>
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm text-gray-600">{item.month}</span>
                    <span className="text-sm font-bold text-gray-900">{item.count}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-blue-600 h-2 rounded-full"
                      style={{ width: `${(item.count / 15) * 100}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Messages by Status */}
          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
              <MessageSquare size={20} className="mr-2 text-green-600" />
              Messages par statut
            </h3>
            <div className="space-y-4">
              {messagesByStatus.map((item, index) => (
                <div key={index}>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-700">{item.status}</span>
                    <span className="text-sm font-bold text-gray-900">{item.count}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3">
                    <div
                      className={`${item.color} h-3 rounded-full`}
                      style={{ width: `${(item.count / stats.totalMessages) * 100}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Top Pharmacies Table */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-6">
          <div className="p-6 border-b border-gray-200">
            <h3 className="text-lg font-bold text-gray-900 flex items-center">
              <Building2 size={20} className="mr-2 text-green-600" />
              Pharmacies les plus actives
            </h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Pharmacie</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Messages</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Statut</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {topPharmacies.map((pharmacy, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div className="flex items-center space-x-3">
                        <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
                          <Building2 className="text-white" size={16} />
                        </div>
                        <span className="font-medium text-gray-900">{pharmacy.name}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-bold">
                        {pharmacy.messages} messages
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                        pharmacy.status === 'active' 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-yellow-100 text-yellow-700'
                      }`}>
                        {pharmacy.status === 'active' ? 'Actif' : 'Incomplet'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Duty Schedule Stats */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="p-6 border-b border-gray-200">
            <h3 className="text-lg font-bold text-gray-900 flex items-center">
              <Calendar size={20} className="mr-2 text-purple-600" />
              Plannings de garde (Novembre 2025)
            </h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Période</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Pharmacies</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Statut</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {dutyScheduleStats.map((week, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <span className="font-medium text-gray-900">{week.period}</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-gray-700">{week.pharmacies} pharmacie(s)</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-bold flex items-center w-fit ${
                        week.published 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-orange-100 text-orange-700'
                      }`}>
                        {week.published ? (
                          <>
                            <CheckCircle2 size={14} className="mr-1" />
                            Publié
                          </>
                        ) : (
                          <>
                            <Clock size={14} className="mr-1" />
                            Brouillon
                          </>
                        )}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ReportsSobre;